module.exports = __webpack_public_path__ + "img/cloudplatform_1.18bee51c.png";